import { render, staticRenderFns } from "./TransactionLinkOrders.vue?vue&type=template&id=b702759c&scoped=true&"
import script from "./TransactionLinkOrders.vue?vue&type=script&lang=js&"
export * from "./TransactionLinkOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b702759c",
  null
  
)

export default component.exports